export default __webpack_public_path__ + "static/media/no-data.e3d747ae.svg";